import { Reducer } from 'redux'
import { actionTypes as ReactReduxFirebaseActionTypes } from 'react-redux-firebase'
import { camelizeKeys } from 'humps'
import { DeliveryTrackingState, DeliveryData, DeliveryTrackingActionTypes } from './types'

const initialState: DeliveryTrackingState = {
  deliveryData: new DeliveryData({}),
  loading: true,
  found: false,
  showReschedule: false,
  rescheduleRequested: false,
}

const reducer: Reducer<DeliveryTrackingState> = (state = initialState, action) => {
  let found
  switch (action.type) {
    case ReactReduxFirebaseActionTypes.SET:
      found = action.data != null
      return {
        ...state,
        loading: false,
        found,
        deliveryData: new DeliveryData(camelizeKeys(action.data || {})),
      }
    case DeliveryTrackingActionTypes.RESCHEDULE_OPEN:
      return {
        ...state,
        showReschedule: true,
      }
    case DeliveryTrackingActionTypes.RESCHEDULE_CLOSE:
      return {
        ...state,
        showReschedule: false,
      }
    case DeliveryTrackingActionTypes.RESCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case DeliveryTrackingActionTypes.RESCHEDULE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        rescheduleRequested: true,
      }
    case DeliveryTrackingActionTypes.RESCHEDULE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}

export { reducer as DeliveryTrackingReducer }
